<template>
  <div class="quick-selected-wrapper">
    <el-card shadow="never">
      <span slot="header" class="font-16">已选转化</span>
      <app-table
        ref="selected-table"
        :table-key="table_key"
        :table-list-data="tableSources"
        class="mt-20"
        check-key="alias"
        :check="true"
        :is-row-click="true"
        :is-reserve-checked="true"
        @select-tr="onSelectionChange"
      />
    </el-card>
    <div
      :class="[showClear ? 'visible' : 'invisible']"
      class="text-right mt-20"
    >
      <el-button
        size="mini"
        type="danger"
        icon="el-icon-delete"
        @click="onClearAll"
      >清除所有</el-button>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  props: {
    tableSources: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      multiple_selection: [],
    };
  },
  computed: {
    showClear() {
      return this.tableSources.list.some((row) => {
        return !isEmpty(row.conversion);
      });
    },
  },
  methods: {
    /**
     * 更新表格
     * @returns {void}
     */
    refreshTable() {
      this.$refs['selected-table'].refer();
    },
    /**
     * 移除模板
     * @param {Object} row 当前行数据
     * @returns {void}
     */
    onRemove(row) {
      const { alias } = row;
      const list = this.tableSources.list;
      const match = list.find(row => row.alias === alias);
      match && this.$set(match, 'conversion', '');
      this.refreshTable();
    },
    /**
     * 多选
     * @param {Array} values 选中的行数据组成的数组
     * @returns {void}
     */
    onSelectionChange(values) {
      this.multiple_selection = values;
    },
    /**
     * 清除所有模板
     * @returns {void}
     */
    onClearAll() {
      this.tableSources.list.forEach(row => this.onRemove(row));
    },
  },
};
</script>
